export enum TableFilterType {
  list = 'list',
  text = 'text',
  dateInterval = 'dateInterval',
  timeInterval = 'timeInterval',
  numberInterval = 'numberInterval',
  boolean = 'boolean'
}
